import { ComponentType, MouseEvent } from 'react';

import { NewCoreIconProps } from '@atlaskit/icon/dist/types/types';
import ClockIcon from '@atlaskit/icon/core/clock';
import AiAgentIcon from './ai-agent-icon';
import ShortcutIcon from '@atlaskit/icon/core/shortcut';
import SettingsIcon from '@atlaskit/icon/core/settings';
import CustomizeIcon from '@atlaskit/icon/core/customize';
import AttachmentIcon from '@atlaskit/icon/core/attachment';
import AddIcon from '@atlaskit/icon/core/add';
import GlobeIcon from '@atlaskit/icon/core/globe';
import CrossIcon from '@atlaskit/icon/core/cross';
import AiGenerativeTextSummaryIcon from '@atlaskit/icon/core/ai-generative-text-summary';
import ArrowUpIcon from '@atlaskit/icon/core/arrow-up';
import CopyIcon from '@atlaskit/icon/core/copy';
import EditIcon from '@atlaskit/icon/core/edit';
import RefreshIcon from '@atlaskit/icon/core/refresh';
import ArchiveBoxIcon from '@atlaskit/icon/core/archive-box';
import PageIcon from '@atlaskit/icon/core/page';
import CheckCircleIcon from '@atlaskit/icon/core/check-circle';
import SearchIcon from '@atlaskit/icon/core/search';
import CheckMarkIcon from '@atlaskit/icon/core/check-mark';
import UploadIcon from '@atlaskit/icon/core/upload';
import CrossCircleIcon from '@atlaskit/icon/core/cross-circle';
import PersonIcon from '@atlaskit/icon/core/person';
import ChevronLeftIcon from '@atlaskit/icon/core/chevron-left';
import ChevronRightIcon from '@atlaskit/icon/core/chevron-right';
import MenuIcon from '@atlaskit/icon/core/menu';
import LockLockedIcon from '@atlaskit/icon/core/lock-locked';
import LogOutIcon from '@atlaskit/icon/core/log-out';
import ArrowLeftIcon from '@atlaskit/icon/core/arrow-left';
import ArrowDownIcon from '@atlaskit/icon/core/arrow-down';
import ChevronUpIcon from '@atlaskit/icon/core/chevron-up';
import ChevronDownIcon from '@atlaskit/icon/core/chevron-down';
import LinkIcon from '@atlaskit/icon/core/link';
import LinkExternalIcon from '@atlaskit/icon/core/link-external';
import QuestionCircleIcon from '@atlaskit/icon/core/question-circle';
import CloudArrowUpIcon from '@atlaskit/icon/core/cloud-arrow-up';
import PeopleGroupIcon from '@atlaskit/icon/core/people-group';
import FileIcon from '@atlaskit/icon/core/file';
import EmailIcon from '@atlaskit/icon/core/email';
import DeleteIcon from '@atlaskit/icon/core/delete';
import DownloadIcon from '@atlaskit/icon/core/download';
import SendIcon from '@atlaskit/icon/core/send';
import ListChecklistIcon from '@atlaskit/icon/core/list-checklist';
import AlertIcon from '@atlaskit/icon/core/alert';
import ErrorIcon from '@atlaskit/icon/core/error';
import PersonWarningIcon from '@atlaskit/icon/core/person-warning';
import PriorityBlockerIcon from '@atlaskit/icon/core/priority-blocker';
import ToolsIcon from '@atlaskit/icon/core/tools';
import StatusInformationIcon from '@atlaskit/icon/core/status-information';
import HomeIcon from '@atlaskit/icon/core/home';
import AppSwitcherIcon from '@atlaskit/icon/core/app-switcher';
import CloudIcon from '@atlaskit/icon-lab/core/cloud';
import StarStarredIcon from '@atlaskit/icon/core/star-starred';
import ServiceIcon from '@atlaskit/icon-lab/core/service';
import StarUnstarredIcon from '@atlaskit/icon/core/star-unstarred';
import ProblemIcon from '@atlaskit/icon/core/problem';
import DragHandleVerticalIcon from '@atlaskit/icon/core/drag-handle-vertical';
import SortAscendingIcon from '@atlaskit/icon/core/sort-ascending';
import AiChatIcon from '@atlaskit/icon/core/ai-chat';
import BookOpenIcon from '@atlaskit/icon-lab/core/book-open';
import ShowMoreHorizontalIcon from '@atlaskit/icon/core/show-more-horizontal';
import ShowMoreVerticalIcon from '@atlaskit/icon/core/show-more-vertical';
import PinIcon from '@atlaskit/icon/core/pin';
import PinFilledIcon from '@atlaskit/icon/core/pin-filled';
import CalendarIcon from '@atlaskit/icon/core/calendar';
import SidebarExpandIcon from '@atlaskit/icon/core/sidebar-expand';
import SidebarCollapseIcon from '@atlaskit/icon/core/sidebar-collapse';

export type IconColor =
  | 'white'
  | 'black'
  | 'grey'
  | 'active'
  | 'success'
  | 'error'
  | 'link'
  | 'warning'
  | 'primary';

export type IconType =
  | 'person'
  | 'chevron-left'
  | 'chevron-right'
  | 'menu'
  | 'lock'
  | 'log-out'
  | 'globe'
  | 'tools'
  | 'close'
  | 'search'
  | 'refresh'
  | 'plus'
  | 'arrow-left'
  | 'arrow-down'
  | 'arrow-up'
  | 'arrow-circle-up'
  | 'text-file'
  | 'edit'
  | 'google'
  | 'password'
  | 'email-lock'
  | 'delete'
  | 'copy'
  | 'save'
  | 'cancel'
  | 'group'
  | 'lock-person'
  | 'send'
  | 'upload-file'
  | 'done'
  | 'history'
  | 'task'
  | 'network-error'
  | 'error'
  | 'cloud'
  | 'cloud-upload'
  | 'pending'
  | 'build-circle'
  | 'shortcut'
  | 'deny'
  | 'link'
  | 'open-tab'
  | 'contact-support'
  | 'magic'
  | 'settings'
  | 'subject'
  | 'manage-search'
  | 'check-circle'
  | 'expand-less'
  | 'expand-more'
  | 'assistant'
  | 'attach-file'
  | 'display-settings'
  | 'info-circle'
  | 'home'
  | 'app-switcher'
  | 'favorite'
  | 'service'
  | 'unfavorite'
  | 'problem'
  | 'drag-handle'
  | 'sort-asc'
  | 'ai-chat'
  | 'catalog'
  | 'menu-dots'
  | 'menu-dots-vert'
  | 'archive'
  | 'unarchive'
  | 'pin'
  | 'unpin'
  | 'calendar'
  | 'sidebar-expand'
  | 'sidebar-collapse';

type AtlasIconComponent = ComponentType<NewCoreIconProps>;

export const IconMap: Map<IconType, AtlasIconComponent> = new Map();
IconMap.set('person', PersonIcon);
IconMap.set('chevron-left', ChevronLeftIcon);
IconMap.set('chevron-right', ChevronRightIcon);
IconMap.set('menu', MenuIcon);
IconMap.set('lock', LockLockedIcon);
IconMap.set('log-out', LogOutIcon);
IconMap.set('globe', GlobeIcon);
IconMap.set('tools', ToolsIcon);
IconMap.set('close', CrossIcon);
IconMap.set('search', SearchIcon);
IconMap.set('refresh', RefreshIcon);
IconMap.set('plus', AddIcon);
IconMap.set('arrow-left', ArrowLeftIcon);
IconMap.set('arrow-down', ArrowDownIcon);
IconMap.set('arrow-up', ArrowUpIcon);
IconMap.set('arrow-circle-up', ArrowUpIcon);
IconMap.set('text-file', FileIcon);
IconMap.set('edit', EditIcon);
IconMap.set('google', GlobeIcon);
IconMap.set('password', LockLockedIcon);
IconMap.set('email-lock', EmailIcon);
IconMap.set('delete', DeleteIcon);
IconMap.set('copy', CopyIcon);
IconMap.set('save', DownloadIcon);
IconMap.set('cancel', CrossCircleIcon);
IconMap.set('group', PeopleGroupIcon);
IconMap.set('lock-person', PersonWarningIcon);
IconMap.set('send', SendIcon);
IconMap.set('upload-file', UploadIcon);
IconMap.set('done', CheckMarkIcon);
IconMap.set('history', ClockIcon);
IconMap.set('task', ListChecklistIcon);
IconMap.set('shortcut', ShortcutIcon);
IconMap.set('network-error', AlertIcon);
IconMap.set('error', ErrorIcon);
IconMap.set('cloud-upload', CloudArrowUpIcon);
IconMap.set('cloud', CloudIcon as unknown as AtlasIconComponent);
IconMap.set('pending', ClockIcon);
IconMap.set('build-circle', CustomizeIcon);
IconMap.set('deny', PriorityBlockerIcon);
IconMap.set('link', LinkIcon);
IconMap.set('open-tab', LinkExternalIcon);
IconMap.set('contact-support', QuestionCircleIcon);
IconMap.set('magic', AiGenerativeTextSummaryIcon);
IconMap.set('settings', SettingsIcon);
IconMap.set('subject', PageIcon);
IconMap.set('manage-search', ArchiveBoxIcon);
IconMap.set('check-circle', CheckCircleIcon);
IconMap.set('expand-less', ChevronUpIcon);
IconMap.set('expand-more', ChevronDownIcon);
IconMap.set('assistant', AiAgentIcon);
IconMap.set('attach-file', AttachmentIcon);
IconMap.set('display-settings', CustomizeIcon);
IconMap.set('info-circle', StatusInformationIcon);
IconMap.set('home', HomeIcon);
IconMap.set('app-switcher', AppSwitcherIcon);
IconMap.set('favorite', StarStarredIcon);
IconMap.set('service', ServiceIcon as unknown as AtlasIconComponent);
IconMap.set('unfavorite', StarUnstarredIcon);
IconMap.set('problem', ProblemIcon);
IconMap.set('drag-handle', DragHandleVerticalIcon);
IconMap.set('sort-asc', SortAscendingIcon);
IconMap.set('ai-chat', AiChatIcon);
IconMap.set('catalog', BookOpenIcon as unknown as AtlasIconComponent);
IconMap.set('menu-dots', ShowMoreHorizontalIcon);
IconMap.set('menu-dots-vert', ShowMoreVerticalIcon);
IconMap.set('archive', ArchiveBoxIcon);
IconMap.set('pin', PinIcon);
IconMap.set('unpin', PinFilledIcon);
IconMap.set('calendar', CalendarIcon);
IconMap.set('sidebar-expand', SidebarExpandIcon);
IconMap.set('sidebar-collapse', SidebarCollapseIcon);

export interface Props {
  name: IconType;
  onClick?: (event?: MouseEvent<HTMLDivElement>) => void;
  spinOnClick?: boolean;
  pop?: boolean;
  background?: 'first' | 'second';
  className?: string;
  color?: IconColor;
  size?: 'medium' | 'x-small' | 'small' | 'large' | 'x-large';
  disabled?: boolean;
  testId?: string;
}
